module.exports = __webpack_public_path__ + "static/dac-9531a8c3c2bd8ee00433138848b2cf54.jpg";